// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_bnA","cls2":"ReferenceEvaluationPage-cls2_Vl5 ReferenceEvaluationPage-cls1_bnA"};